module.exports = __webpack_public_path__ + "img/1970East-068_WEB-min.d1c4310e.jpg";